module.exports = __webpack_public_path__ + "media/newstyle/images/icon-person-grey-8ec1d08cd004a27464915bb9d0c79273.svg";